module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#online-news",
      toString: function () {
        return this.url;
      }
    }